'use client';

import { c as _c } from "react/compiler-runtime";
import { sendFeedback } from '@/app/actions';
import Comment from '@mui/icons-material/Comment';
import DeleteForever from '@mui/icons-material/DeleteForever';
import Send from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Modal } from '@shared/components/Modal';
import { ToastType, useToast } from '@shared/context/Toast';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { useServerHandler } from '@shared/hooks/useServerHandler';
import { FeatureAnalyticType } from '@shared/types';
import { useState } from 'react';
const CHARACTER_LIMIT = 400 as const;
export const SuggestionButton: React.FC = () => {
  const $ = _c(41);
  const {
    pushToast
  } = useToast();
  const {
    addAnalytics
  } = useAnalytics();
  const {
    doServerAction,
    isLoading
  } = useServerHandler();
  const [isOpen, setOpen] = useState(false);
  const [comment, setComment] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setOpen(false);
      setComment("");
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeModal = t0;
  let t1;
  if ($[1] !== addAnalytics) {
    t1 = async () => {
      setOpen(true);
      await addAnalytics(FeatureAnalyticType.SEND_FEEDBACK);
    };
    $[1] = addAnalytics;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openModal = t1;
  let t2;
  if ($[3] !== addAnalytics || $[4] !== comment || $[5] !== doServerAction || $[6] !== pushToast) {
    t2 = function handleSendFeedback() {
      doServerAction(() => {
        addAnalytics(FeatureAnalyticType.SUBMIT_FEEDBACK);
        return sendFeedback(comment.trim());
      }, () => {
        pushToast({
          message: "Feedback sent!",
          type: ToastType.success
        });
        closeModal();
      });
    };
    $[3] = addAnalytics;
    $[4] = comment;
    $[5] = doServerAction;
    $[6] = pushToast;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleSendFeedback = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Comment />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== openModal) {
    t4 = <Button variant="outlined" endIcon={t3} color="info" onClick={openModal} size="large">Send Suggestion</Button>;
    $[9] = openModal;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== comment || $[12] !== isLoading) {
    t5 = isLoading || !comment.trim();
    $[11] = comment;
    $[12] = isLoading;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Send />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleSendFeedback || $[16] !== t5) {
    t7 = <Button disabled={t5} onClick={handleSendFeedback} endIcon={t6} variant="contained">Send</Button>;
    $[15] = handleSendFeedback;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => setComment(e.target.value);
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      maxLength: CHARACTER_LIMIT
    };
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = !comment.length;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      mt: "auto"
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setComment("");
    t13 = <DeleteForever />;
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10) {
    t14 = {
      endAdornment: <IconButton disabled={t10} sx={t11} color="error" size="small" onClick={t12}>{t13}</IconButton>
    };
    $[23] = t10;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = comment.length === CHARACTER_LIMIT ? "secondary" : "green";
  const t16 = `${comment.length}/${CHARACTER_LIMIT}`;
  let t17;
  if ($[25] !== t15 || $[26] !== t16) {
    t17 = <Typography fontSize={12} fontWeight={600} textAlign="end" display="block" component="span" color={t15}>{t16}</Typography>;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = comment.length === CHARACTER_LIMIT ? "warning" : "primary";
  let t19;
  if ($[28] !== comment || $[29] !== t14 || $[30] !== t17 || $[31] !== t18) {
    t19 = <TextField fullWidth={true} required={true} autoFocus={true} multiline={true} rows={6} margin="dense" onChange={t8} value={comment} label={"\u0307Write a suggestion"} inputProps={t9} InputProps={t14} helperText={t17} color={t18} />;
    $[28] = comment;
    $[29] = t14;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== isLoading || $[34] !== isOpen || $[35] !== t19 || $[36] !== t7) {
    t20 = <Modal isOpen={isOpen} onClose={closeModal} title="Send Us A Suggestion" fullWidth={true} actions={t7} isLoading={isLoading}>{t19}</Modal>;
    $[33] = isLoading;
    $[34] = isOpen;
    $[35] = t19;
    $[36] = t7;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t20 || $[39] !== t4) {
    t21 = <>{t4}{t20}</>;
    $[38] = t20;
    $[39] = t4;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
};